export function getFileNameWithoutHash(fileName: string) {
    const hashedFileRegex = /(?<name>.+)[.][a-zA-Z0-9]+[.]hashedasset[.](?<extension>.+)/g;
    const match = hashedFileRegex.exec(fileName);
    if (match === null) {
        // File has not been hashed
        return fileName;
    }

    if (match.groups === undefined || match.groups.name === undefined || match.groups.extension === undefined) {
        // Found a filename with a hash, but couldn't parse the other parts of the file successfully
        return fileName;
    }
    return `${match.groups.name}.${match.groups.extension}`;
}
